import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatOptionModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatChipsModule } from '@angular/material/chips';
import { AnimIconComponent } from './components/anim-icon/anim-icon.component';
import { CommentComponent } from './components/comment/comment.component';
import { ConfirmationDialogComponent } from './components/confirmation-dialog/confirmation-dialog.component';
import { DropdownComponent } from './components/dropdown/dropdown.component';
import { InformationTagComponent } from './components/information-tag/information-tag.component';
import { InputComponent } from './components/input/input.component';
import { LoadingScreenComponent } from './components/loading-screen/loading-screen.component';
import { TurbineComponent } from './components/loading-screen/turbine/turbine.component';
import { DynamicDomAccessDirective } from './directives/dynamic-dom-access.directive';
import { TwoDecimalPlacesDirective } from './directives/two-decimal-places.directive';
import {
  ByteToSizePipe,
  ContractStatusTranslation,
  DateTimezoneFixPipe,
  MgmtGroupTranslationPipe,
  ThousandsSeparatorPipe,
  TwoDecimalPlacesPipe
} from './pipes';
import { EmployeeNamePipe } from './pipes/employee-name.pipe';
import { EnumToTextPipe } from './pipes/enum-to-text.pipe';
import { IsoToCountryPipe } from './pipes/iso-to-country.pipe';
import { ContractStatusColorPipe } from './pipes/contract-status-color.pipe';
import { MultiplicationPipe } from './pipes/multiplication.pipe';
import { ChipInputComponent } from './components/chip-input/chip-input.component';
import { V2ButtonComponent, V2CheckboxComponent, V2TextInputComponent } from '@coin/shared/core/ui-storybook';

@NgModule({
  declarations: [
    TurbineComponent,
    LoadingScreenComponent,
    CommentComponent,
    ConfirmationDialogComponent,
    InputComponent,
    DropdownComponent,
    ByteToSizePipe,
    DynamicDomAccessDirective,
    InformationTagComponent,
    TwoDecimalPlacesDirective,
    EnumToTextPipe,
    EmployeeNamePipe,
    ContractStatusColorPipe,
    MultiplicationPipe,
    TwoDecimalPlacesPipe,
    DateTimezoneFixPipe,
    AnimIconComponent,
    MgmtGroupTranslationPipe,
    IsoToCountryPipe,
    ThousandsSeparatorPipe,
    ContractStatusTranslation,
    ChipInputComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    DragDropModule,
    MatIconModule,
    FormsModule,
    MatInputModule,
    MatSelectModule,
    MatIconModule,
    MatTooltipModule,
    MatCheckboxModule,
    MatOptionModule,
    MatDatepickerModule,
    MatChipsModule,
    V2ButtonComponent,
    V2CheckboxComponent,
    V2TextInputComponent
  ],
  exports: [
    TurbineComponent,
    LoadingScreenComponent,
    CommentComponent,
    ConfirmationDialogComponent,
    InputComponent,
    DropdownComponent,
    ByteToSizePipe,
    DynamicDomAccessDirective,
    InformationTagComponent,
    TwoDecimalPlacesDirective,
    EnumToTextPipe,
    ContractStatusColorPipe,
    MultiplicationPipe,
    EmployeeNamePipe,
    TwoDecimalPlacesPipe,
    DateTimezoneFixPipe,
    AnimIconComponent,
    MgmtGroupTranslationPipe,
    ThousandsSeparatorPipe,
    ContractStatusTranslation,
    ChipInputComponent,
    V2ButtonComponent,
    V2CheckboxComponent,
    V2TextInputComponent
  ],
  providers: [ContractStatusTranslation, MgmtGroupTranslationPipe]
})
export class UiModule {}
